export default class TableOfContents {
  constructor() {
    this.tocs = document.querySelectorAll('[data-table-of-contents]');
  }

  init() {
    if (!this.tocs.length) return;

    this.tocs.forEach((toc) => {
      this.buildToc(toc);
      this.setupToc(toc);
    });
  }

  buildToc(toc) {
    const list = toc.querySelector('.table-of-contents__list');
    if (!list) return;

    const headings = [...document.querySelectorAll('.wp-block-post-content h2')];
    if (!headings.length) return;

    const items = headings.map((heading) => {
      if (!heading.id) {
        const slug = heading.textContent.trim().toLowerCase().replace(/[^\w]+/g, '-');
        heading.id = slug;
      }

      return `<a href="#${heading.id}" class="table-of-contents__link">${heading.textContent.trim()}</a>`;
    });

    list.innerHTML = items.join('');
  }

  setupToc(toc) {
    const title = toc.querySelector('.table-of-contents__title');
    const list = toc.querySelector('.table-of-contents__list');
    if (!title || !list) return;

    title.addEventListener('click', (event) => this.handleTitleClick(event, toc));
    list.addEventListener('click', (event) => this.handleListClick(event, toc));
    document.addEventListener('click', (event) => this.handleOutsideClick(event, toc));
    document.addEventListener('click', (event) => this.handleSmoothScroll(event));
  }

  handleTitleClick(event, toc) {
    event.stopPropagation();
    const isOpen = toc.dataset.expanded === 'true';
    this.toggleToc(toc, !isOpen);
  }

  handleListClick(event, toc) {
    const linkClicked = event.target.closest('a');
    if (linkClicked) this.toggleToc(toc, false);
  }

  handleOutsideClick(event, toc) {
    const clickedOutside = !toc.contains(event.target);
    if (clickedOutside) this.toggleToc(toc, false);
  }

  toggleToc(toc, open = false) {
    const title = toc.querySelector('.table-of-contents__title');
    const list = toc.querySelector('.table-of-contents__list');

    toc.dataset.expanded = open;
    list.hidden = !open;
    title.setAttribute('aria-expanded', String(open));
  }

  handleSmoothScroll(event) {
    const link = event.target.closest('.table-of-contents__link');
    if (!link) return;

    const targetSelector = link.getAttribute('href');
    const target = document.querySelector(targetSelector);
    if (!target) return;

    event.preventDefault();

    const HEADER_OFFSET = 150;
    const position = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;

    window.scrollTo({
      top: position,
      behavior: 'smooth',
    });

    history.pushState(null, '', `#${target.id}`);
  }
}
